import React from 'react';

const ExVat = () => {
	return (
		<div className="text-caption text-left">Ex VAT</div>
	);
};

export default ExVat;
